import { Omit } from '@material-ui/core';
import Grid, { GridProps } from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';

interface OwnProps extends Omit<GridProps, 'classes'> {}

interface SectionProps extends OwnProps, WithStyles<typeof styles> {}

const SectionBase: FunctionComponent<SectionProps> = ({
  children,
  classes,
  justify,
  alignItems,
  alignContent,
  spacing,
  direction,
  ...props
}) => (
  <Grid
    container
    item
    xs
    wrap="nowrap"
    alignContent="stretch"
    alignItems="stretch"
    {...props}
  >
    <Grid
      container
      item
      zeroMinWidth
      className={classes.root}
      wrap="nowrap"
      justify={justify}
      alignItems={alignItems}
      alignContent={alignContent}
      spacing={spacing || 16}
      direction={direction}
    >
      {children}
    </Grid>
  </Grid>
);

// styled
const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing.unit * 2,
    },
  });

const enhance = compose<SectionProps, OwnProps>(
  pure,
  withStyles(styles),
);

export const Section = enhance(SectionBase);

Section.displayName = 'Section';
